import { createSlice } from '@reduxjs/toolkit';
import {
  getTop5Posts,
  getBottom5Posts,
  getCreativeVsMediaScatterPlot,
} from '@/services/aiMeasurementService';
import { logoutUser } from '@/store/slices/authSlice';
import {
  Top5PostsResponse,
  Bottom5PostsResponse,
  Top5PostsParams,
  Bottom5PostsParams,
  AiScatterResponse,
  AiScatterParams,
} from '@/types/aiMeasurement.types';
import {
  DataStateWithParams,
  createDataAsyncThunk,
  addDataAsyncCasesWithParams,
} from '@/store/utils/asyncThunkHelpers';

interface AIMeasurementState {
  top5Posts: DataStateWithParams<Top5PostsResponse, Top5PostsParams>;
  bottom5Posts: DataStateWithParams<Bottom5PostsResponse, Bottom5PostsParams>;
  scatterPlot: DataStateWithParams<AiScatterResponse, AiScatterParams>;
}

const initialState: AIMeasurementState = {
  top5Posts: { data: null, status: 'idle', error: null },
  bottom5Posts: { data: null, status: 'idle', error: null },
  scatterPlot: { data: null, status: 'idle', error: null },
};

export const fetchTop5Posts = createDataAsyncThunk<Top5PostsResponse, Top5PostsParams>(
  'aiMeasurement/fetchTop5Posts',
  getTop5Posts
);

export const fetchBottom5Posts = createDataAsyncThunk<Bottom5PostsResponse, Bottom5PostsParams>(
  'aiMeasurement/fetchBottom5Posts',
  getBottom5Posts
);

export const fetchScatterPlot = createDataAsyncThunk<AiScatterResponse, AiScatterParams>(
  'aiMeasurement/fetchScatterPlot',
  getCreativeVsMediaScatterPlot
);

const aiMeasurementSlice = createSlice({
  name: 'aiMeasurement',
  initialState,
  reducers: {},
  extraReducers: builder => {
    addDataAsyncCasesWithParams(builder, fetchTop5Posts, state => state.top5Posts);
    addDataAsyncCasesWithParams(builder, fetchBottom5Posts, state => state.bottom5Posts);
    addDataAsyncCasesWithParams(builder, fetchScatterPlot, state => state.scatterPlot);

    // Reset state on logout
    builder.addCase(logoutUser.fulfilled, () => {
      return initialState;
    });
  },
});

export default aiMeasurementSlice.reducer;
